"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealAbilityHandler = exports.HealActorAbilityFactory = exports.HealAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class HealAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Heal;
        this.__typeName = "Heal";
    }
}
exports.HealAbilityArgs = HealAbilityArgs;
let HealActorAbilityFactory = class HealActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Heal", "OneAllies", 0);
    }
};
HealActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Heal")
], HealActorAbilityFactory);
exports.HealActorAbilityFactory = HealActorAbilityFactory;
let HealAbilityHandler = class HealAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAllyOrSelf] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId: selectedAllyOrSelf,
                    amount: container.getPercentOfBaseHealth(selectedAllyOrSelf, 10),
                    attributePercent: 100,
                    onApplied: (sequence) => {
                        sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAllyOrSelf, "feet"), "BlueHealingWinds"));
                        container.applyBuff({
                            sequence,
                            creatorId: ability.invokerId,
                            targetId: selectedAllyOrSelf,
                            duration: Duration_1.Duration.Turns(3),
                            effect: new core_1.RegenerationEffectArgs("Heal", container.getPercentOfBaseHealth(selectedAllyOrSelf, 1))
                        });
                    }
                });
            }
        });
    }
};
HealAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Heal)
], HealAbilityHandler);
exports.HealAbilityHandler = HealAbilityHandler;
